import type { Maybe } from '@adornis/base/utilTypes.js';
import type { UserRole } from '@ils/static/enums.js';
import type { User } from './permissions.js';
import { roleMapping } from './roleMapping.js';
import { permissions } from './roles/permissions.js';

export const getExamDayFilter = (user?: Maybe<User>) => {
  if (!user) return permissions.noUser.examDayFilter({ _id: 'NO_USER', roles: [] });
  const userRoles = user.roles.map(role => roleMapping[role.name] ?? role.name) as UserRole[];
  const filter: any[] = [];
  for (const role of userRoles) {
    const roleFilter = permissions[role].examDayFilter(user);
    if (roleFilter) filter.push(roleFilter);
  }
  return { $or: filter };
};
